import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { VehicleForm } from "./VehicleForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IVehicleCreateProps {}

export const VehicleCreate = (props: IVehicleCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Vehicle,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-vehicles.title.create"
        transform={(data) => ({
          ...data,
          name: data.name.trim(),
        })}
      >
        <VehicleForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
